import {
  Container,
  FormikForm,
  FormikSubmitButton,
  FormikTextField,
  Spacer,
  Title,
  useDialogState,
  useToast,
} from '@color/continuum';
import { navigateAndRefreshBrowser } from '@color/lib';
import { Formik } from 'formik';
import { generatePath } from 'react-router-dom';

import { CreateHealthHistoryDialog } from 'ui/Clinical/GenericHealthHistory/CreateHealthHistoryDialog';

import { fetchHealthHistory } from './api';
import { GENERIC_HEALTH_HISTORY_SHOW_PATH } from './paths';
import { HealthHistorySearchFormikValues } from './types';

export const HealthHistoryPage = () => {
  const { closeDialog, openDialog, dialogIsOpen } = useDialogState();
  const { showErrorToast } = useToast();

  return (
    <Container maxWidth="md">
      {dialogIsOpen && (
        <CreateHealthHistoryDialog dialogIsOpen={dialogIsOpen} closeDialog={closeDialog} />
      )}
      <Title>Find Health History</Title>
      <Spacer variant="medium" />
      <Formik<HealthHistorySearchFormikValues>
        initialValues={{
          query: '',
        }}
        onSubmit={async (values: HealthHistorySearchFormikValues) => {
          const { query } = values;
          try {
            const healthHistoryResponse = await fetchHealthHistory(query);
            if (healthHistoryResponse) {
              navigateAndRefreshBrowser(
                generatePath(GENERIC_HEALTH_HISTORY_SHOW_PATH, {
                  id: healthHistoryResponse.id!,
                })
              );
            }
          } catch (error) {
            if (error.status === 404) {
              showErrorToast('No Health History found. Please create one.');
              openDialog();
            } else {
              showErrorToast('An unexpected error occurred.');
            }
          }
        }}
      >
        <FormikForm>
          <FormikTextField
            name="query"
            type="text"
            label="Patient ID, email, order number or sample ID"
            required
            autoFocus
          />
          <Spacer variant="medium" />
          <FormikSubmitButton isLoading={false}>Find</FormikSubmitButton>
        </FormikForm>
      </Formik>
    </Container>
  );
};
